// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__Gc7Ea","label":"CheckBox_label__CDu0D","input":"CheckBox_input__WrctF","primary":"CheckBox_primary__H0UR7","secondary":"CheckBox_secondary__aKNhb"};